import { Col, DatePicker, Form, Input, Row } from 'antd';
import MaskedInput from 'antd-mask-input';
import React, { FC } from 'react';
import { ExtendedSearchFormProps } from '../service-find-admin.type';
import { filterDigits, localize } from '/react4xp/mixins/helpers';
import { dateFormat } from '/react4xp/parts/questionnaire-ogd/questionnaire-ogd';

const { RangePicker } = DatePicker;

const ExtendedSearchForm: FC = ({ disabledDate, form, ...props }: ExtendedSearchFormProps) => {
    const {
        address,
        email,
        phone,
        beginDate,
        existingRehabilitationCount,
        closedRehabilitationCount,
        inspectionCount,
        existingBankruptcyCount,
        closedBankruptcyCount,
        experience,
        certificate,
        otherDocument,
    } = props.config;

    return (
        <Row gutter={15}>
            <Col
                xs={24}
                md={8}
            >
                <Form.Item
                    label={address}
                    name="address"
                >
                    <Input placeholder={localize('placeholder.input', props.commonTranslations)} />
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={8}
            >
                <Form.Item
                    label={email}
                    name="email"
                >
                    <Input placeholder={localize('placeholder.input', props.commonTranslations)} />
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={8}
            >
                <Form.Item
                    label={phone}
                    name="phone"
                    rules={[
                        {
                            pattern: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
                            message: localize('validation.phone-format', props.commonTranslations),
                        },
                    ]}
                >
                    <MaskedInput
                        mask="+7 (000) 000-00-00"
                        placeholder={localize('placeholder.phone', props.commonTranslations)}
                    />
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item
                    label={beginDate}
                    name="beginDate"
                >
                    <RangePicker
                        format={dateFormat}
                        disabledDate={disabledDate}
                        placeholder={[
                            localize('placeholder.from', props.commonTranslations),
                            localize('placeholder.to', props.commonTranslations),
                        ]}
                    />
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item label={existingRehabilitationCount}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name="existingRehabilitationCountFrom"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.from',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'existingRehabilitationCountFrom')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="existingRehabilitationCountTo"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.to',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'existingRehabilitationCountTo')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item label={closedRehabilitationCount}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name="closedRehabilitationCountFrom"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.from',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'closedRehabilitationCountFrom')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="closedRehabilitationCountTo"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.to',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'closedRehabilitationCountTo')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item label={inspectionCount}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name="inspectionCountFrom"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.from',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'inspectionCountFrom')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="inspectionCountTo"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.to',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'inspectionCountTo')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item label={existingBankruptcyCount}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name="existingBankruptcyCountFrom"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.from',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'existingBankruptcyCountFrom')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="existingBankruptcyCountTo"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.to',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'existingBankruptcyCountTo')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item label={closedBankruptcyCount}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name="closedBankruptcyCountFrom"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.from',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'closedBankruptcyCountFrom')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="closedBankruptcyCountTo"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.to',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'closedBankruptcyCountTo')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
            </Col>

            <Col
                xs={24}
                md={12}
            >
                <Form.Item label={experience}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name="experienceFrom"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.from',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'experienceFrom')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="experienceTo"
                                noStyle
                            >
                                <Input
                                    placeholder={localize(
                                        'placeholder.to',
                                        props.commonTranslations
                                    )}
                                    onChange={filterDigits(form, 'experienceTo')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item
                    label={certificate}
                    name="certificate"
                >
                    <Input placeholder={localize('placeholder.input', props.commonTranslations)} />
                </Form.Item>
            </Col>
            <Col
                xs={24}
                md={12}
            >
                <Form.Item
                    label={otherDocument}
                    name="otherDocument"
                >
                    <Input placeholder={localize('placeholder.input', props.commonTranslations)} />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default ExtendedSearchForm;
